import type { RouteRecordRaw } from 'vue-router'
import { RoleHelper } from '@/helpers/RoleHelper.ts'
import TitropSettingsView from '@/views/other/TitropSettingsView.vue'
import { AccountIcon, AccountSettingsIcon, FavoriteIcon, SecurityIcon, SiteSettingsIcon } from '@/config/icons.ts'

const NotImplementedView = async () => import('@/views/NotImplementedView.vue')

const SecurityView = async () => import('@/views/preference/SecurityView.vue')
const MyProfileView = async () => import('@/views/MyProfileView.vue')
const PreferencesView = async () => import('@/views/employee/PreferencesView.vue')
const FavoritesView = async () => import('@/views/favorites/FavoritesView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/profile',
    name: 'profile',
    component: MyProfileView,
    meta: { title: 'Mein Profil' },
    icon: "AccountIcon"
  },

  {
    meta: { title: 'Meine Favoriten' },
    path: '/favorites',
    component: FavoritesView,
    icon: "FavoriteIcon"
  },
  {
    path: '/preferences/user-preferences',
    meta: { title: 'Benutzereinstellungen' },
    name: '',
    component: PreferencesView,
    icon: "AccountSettingsIcon"
  },
  {
    path: '/preferences/user-security',
    meta: { title: 'Sicherheit' },
    name: '',
    component: SecurityView,
    icon: "SecurityIcon"
  },
  {
    path: '/site-settings',
    meta: {
      title: 'Titrop-Einstellungen',
      markAsDev: false,
      security: (roleHelper: RoleHelper) => roleHelper.developer
    },
    name: '',
    component: TitropSettingsView,
    icon: "SiteSettingsIcon"
  }
]

export default routes
